/* eslint-disable import/prefer-default-export */ import * as _Global from "./Global.styles";
export { _Global as Global };
export var CLASS_MAP = {
    LAYOUT_CONTAINER: "layout-container",
    LAYOUT_CONTAINER_CONTENT: "layout-container-content",
    LAYOUT_CONTENT_ONLY_PADDING: "layout-content-only-padding",
    LAYOUT_CONTENT_ONLY_MARGIN: "layout-content-only-margin"
};
